module.exports = __webpack_public_path__ + "static/media/2025_Greenland_Resources.2036f63e.png";